export default "__VITE_ASSET__CbNKHhi9__"